import React from "react";
import { Routes, Route } from "react-router-dom";
import ListInvites from "../Components/Invites/listInvites";
import ViewInvite from "../Components/Invites/viewInvite";
const InvitesRoutes = () => {
  return (
    <Routes>
      <Route path="/invites" element={<ListInvites></ListInvites>}></Route>
         <Route path="/invites/view/:id" element={<ViewInvite></ViewInvite>}></Route>
    </Routes>
  );
};

export default InvitesRoutes;
